import React, { useContext } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import AppContext from "../../shared/AppContext"
import "./style.scss"

const ContentCard = React.forwardRef((props, ref) => {
  const { className = "", children, ...rest } = props
  return (
    <div ref={ref} className={`content-card ${className}`} {...rest}>
      {children}
    </div>
  )
})

ContentCard.propTypes = {
  style: PropTypes.object,
}

export default ContentCard

export const CardTitle = (props) => {
  const { link, title, trackingLocation, ...rest } = props
  const { trackEvent } = useContext(AppContext)

  let Header = (
    <h2 className="content-card-title" style={props.style}>
      {props.title}
    </h2>
  )

  if (link) {
    return (
      <Link
        to={link}
        onClick={() => {
          trackEvent("Card Title", {
            title: title,
            to: link,
            location: trackingLocation,
          })
        }}
        {...rest}
      >
        {Header}
      </Link>
    )
  }

  return Header
}

CardTitle.propTypes = {
  title: PropTypes.string.isRequired,
  link: PropTypes.string,
  location: PropTypes.string, //for tracking
  style: PropTypes.object,
  animation: PropTypes.bool,
}
